import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "monthlyPrice",
    "lifetimeMonths",
    "lifetimeDisplay",
    "newCustomers",
    "customersDisplay",
    "planPrice",
    "lifetimeValue",
    "costPerCustomer",
    "netRoi",
    "breakeven",
    "tableCost"
  ]

  connect() {
    this.calculate()
  }

  calculate() {
    const monthlyPrice = parseFloat(this.monthlyPriceTarget.value) || 150
    const lifetimeMonths = parseInt(this.lifetimeMonthsTarget.value) || 24
    const newCustomers = parseInt(this.newCustomersTarget.value) || 2
    const planPrice = parseFloat(this.planPriceTarget.value) || 99

    // Update display values for sliders
    this.lifetimeDisplayTarget.textContent = `${lifetimeMonths} mo`
    this.customersDisplayTarget.textContent = newCustomers

    // Calculate values
    const lifetimeValue = monthlyPrice * lifetimeMonths
    const costPerCustomer = planPrice / newCustomers
    const netRoi = lifetimeValue - costPerCustomer

    // Calculate break-even (how many customers needed to cover plan cost)
    const monthsToBreakeven = planPrice / monthlyPrice
    const customersPerYearToBreakeven = (planPrice * 12) / lifetimeValue

    // Update output displays
    this.lifetimeValueTarget.textContent = this.formatCurrency(lifetimeValue)
    this.costPerCustomerTarget.textContent = this.formatCurrency(costPerCustomer)
    this.netRoiTarget.textContent = this.formatCurrency(netRoi)
    this.tableCostTarget.textContent = this.formatCurrency(costPerCustomer)

    // Generate break-even statement
    this.breakevenTarget.textContent = this.generateBreakevenStatement(monthsToBreakeven, customersPerYearToBreakeven)
  }

  formatCurrency(amount) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount)
  }

  generateBreakevenStatement(monthsToBreakeven, customersPerYearToBreakeven) {
    if (customersPerYearToBreakeven < 1) {
      // Less than 1 customer per year needed
      const monthsBetweenCustomers = Math.round(12 / customersPerYearToBreakeven)
      if (monthsBetweenCustomers <= 1) {
        return "PoolFlow pays for itself with just 1 new customer per month."
      } else if (monthsBetweenCustomers >= 12) {
        return "PoolFlow pays for itself with just 1 new customer per year."
      } else {
        return `PoolFlow pays for itself with just 1 new customer every ${monthsBetweenCustomers} months.`
      }
    } else if (customersPerYearToBreakeven < 2) {
      return "PoolFlow pays for itself with just 1-2 new customers per year."
    } else {
      const customersNeeded = Math.ceil(customersPerYearToBreakeven)
      return `PoolFlow pays for itself with just ${customersNeeded} new customers per year.`
    }
  }
}
